import { colors } from '@material-ui/core';
import { common } from '@material-ui/core/colors';

export const brandColors = {
  grey: {
    0: '#FFFFFF',
    100: '#FCFAF8',
    200: '#F8F4F1',
    300: '#EFEAE6',
    400: '#D5D1CE',
    500: '#ABA4A0',
    600: '#837F7C',
    700: '#4F4C4B',
    800: '#2E2C2B',
    900: '#181716',
  },
  green: {
    100: '#EAFFF7',
    200: '#CDFEE9',
    300: '#00B487',
    400: '#00A37A',
    500: '#0C493A',
    600: '#09352A',
    700: '#0C2322',
  },
  blue: {
    100: '#F1FAFF',
    200: '#BFE8F8',
    300: '#60D0F0',
    400: '#1F48B1',
    500: '#132C6C',
    600: '#0B1A41',
  },
  red: {
    100: '#FFF0F0',
    200: '#FFDDDD',
    300: '#FFABAB',
    400: '#F23F3A',
    500: '#E6150F',
    600: '#9D1233',
    700: '#590B1A',
  },
  yellow: {
    100: '#FFF9EB',
    200: '#FFDD88',
    300: '#FFC548',
    400: '#F17D10',
    500: '#956321',
    600: '#654817',
  },
};

export const semanticColors = {
  info: { main: colors.blue[500], contrastText: common.white },
  warning: { main: colors.orange[500], contrastText: common.white },
  success: { main: colors.green[500], contrastText: common.white },
  error: { main: colors.red[500], contrastText: common.white },
};

export const contextColors = {
  institutions: { main: brandColors.blue[400], contrastText: common.white },
  sellers: { main: brandColors.green[400], contrastText: common.white },
};
